export default __webpack_public_path__ + "static/media/Loader.53ae9d22.gif";